import { useEffect, useCallback } from "react";

export default function useDebounce(effect, dependencies, delay = 500) {
  const callback = useCallback(effect, dependencies);

  useEffect(() => {
    const timeout = setTimeout(callback, delay);
    return () => clearTimeout(timeout);
  }, [callback, delay]);
}
